import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=3b15b3b3&scoped=true&"
import script from "./NotFoundView.vue?vue&type=script&lang=ts&"
export * from "./NotFoundView.vue?vue&type=script&lang=ts&"
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=3b15b3b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b15b3b3",
  null
  
)

export default component.exports